var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'mixin', 'core', 'model/document', 'app-common/component/inbox-events', 'app-common/component/loader', 'app-common/component/notification', 'component/bk-viewer', 'app-common/view/base', 'component/local-storage', 'component/document-entry/actions-view', 'component/document-entry/details-view', 'component/document-entry/notes-view', 'component/document-entry/generated-name-view', 'component/document-entry/transactions-view', 'component/document-entry/transfer-list-view', 'component/document-entry/document-request-view', 'app-common/component/notes', 'template/simple.htm', 'template/document-entry/landing.htm', 'template/document-entry/header.htm', 'collection/document-requests', 'model/document-request', 'common/lib/forms/jquery.caret', 'common/lib/date', 'common/lib/jquery.resize', 'common/lib/jquery.hotkeys', 'common/lib/json2'], function($, _, _s, Backbone, mixin, core, DocumentModel, inboxEvents, loader, NotificationSupport, BkDocumentViewer, BaseView, LocalStorage, ActionsView, DetailsView, NotesView, GeneratedNameView, TransactionsView, TransfersListView, DocumentRequestView, InternalNotesView, simpleTemplate, landingTemplate, headerTemplate, DocumentRequestsCollection, DocumentRequestModel) {
  var DocumentEntryPage;
  return DocumentEntryPage = (function(_super) {

    __extends(DocumentEntryPage, _super);

    function DocumentEntryPage() {
      this.syncInternalNotes = __bind(this.syncInternalNotes, this);
      DocumentEntryPage.__super__.constructor.apply(this, arguments);
    }

    DocumentEntryPage.prototype.pageId = 'document-entry';

    DocumentEntryPage.prototype.template = landingTemplate;

    DocumentEntryPage.prototype.notFound = false;

    DocumentEntryPage.prototype.navigation = null;

    DocumentEntryPage.prototype.originalId = null;

    DocumentEntryPage.prototype.isTabular = false;

    DocumentEntryPage.prototype.isSingle = false;

    DocumentEntryPage.prototype.documentRequests = null;

    DocumentEntryPage.prototype.documentRequestsModel = null;

    DocumentEntryPage.prototype.mainTypes = ['RECEIPT', 'TRANSACTIONAL', 'STATEMENT', 'TAX', 'EXPORTS', 'INTERNAL'];

    DocumentEntryPage.prototype.addOnTypes = ['MERCHANT_REPORT', 'LOAN_INTEREST_REPORT', 'PAYROLL_REPORT', 'EXPENSE_REPORT'];

    DocumentEntryPage.prototype.otherTypes = ['CHECK', 'INVOICE', 'JUNK', 'OTHER'];

    DocumentEntryPage.prototype.events = {
      'click .document-type:not(.disabled)': function(e) {
        return this.updateType($(e.currentTarget).data('type').toUpperCase(), true);
      },
      'click .relatedJE': 'openRelatedJE',
      'click .manual_matching': 'openPotentialMatches',
      'click #document-prev': 'prev',
      'click #document-next': 'next',
      'click #document-save': 'save',
      'click #document-save-and-exit': 'saveAndExit',
      'click #document-exit': 'exit',
      'click #document-confirm': 'confirm'
    };

    DocumentEntryPage.prototype.initialize = function(options, params) {
      var customNavigation, hasNavigation, init, _ref, _ref1,
        _this = this;
      DocumentEntryPage.__super__.initialize.apply(this, arguments);
      hasNavigation = true;
      this.navigationEventMode = 'ND';
      this.shouldPrefill = ((_ref = options.queryVals) != null ? _ref.prefill : void 0) === 'true';
      if (params.length === 2) {
        this.originalId = params[0];
        if (params[1] === 'single') {
          this.isSingle = true;
          hasNavigation = false;
        } else {
          this.navigationEventMode = params[1];
          hasNavigation = true;
        }
      } else if (params.length === 1) {
        this.originalId = params[0];
      }
      if (((_ref1 = options.queryVals) != null ? _ref1.type : void 0) === 'custom') {
        customNavigation = true;
        this.navigationQuery = options;
      }
      init = function() {
        var attributes, currentIdIndex, eventName, localStorage, resourceIds, _ref2, _ref3, _ref4;
        loader.hide();
        _this.documentRequests = core.getCollection('documentRequests');
        _this.documentRequests.on('destroy', _this.removeDocumentRequestView, _this);
        _this.ledgerAccountsCollection = core.getCollection('ledgerAccounts');
        _this.ledgerAccountsCollection.on('add remove', function() {
          return _this.prepareLedgerControl();
        });
        _this.prepareLedgerControl();
        attributes = _this.model.get('attributes');
        if (!attributes.name && ((_ref2 = _this.model.get('file')) != null ? _ref2.get('displayName') : void 0)) {
          attributes.name = (_ref3 = _this.model.get('file')) != null ? _ref3.get('displayName') : void 0;
          _this.model.set('attributes', attributes);
        }
        _this.isTabular = ((_ref4 = _this.model.get('file')) != null ? _ref4.get('tabular') : void 0) === true;
        if (customNavigation) {
          localStorage = new LocalStorage('deui-custom-' + core.getCurrentUserid());
          resourceIds = localStorage.load().data[core.getCurrentClientId()];
          currentIdIndex = _.indexOf(resourceIds, _this.originalId);
          _this.navigation = {
            nextId: resourceIds[currentIdIndex + 1],
            prevId: resourceIds[currentIdIndex - 1],
            currentPosition: currentIdIndex + 1,
            total: resourceIds.length,
            eventName: 'feed.statement.created'
          };
        } else if (_this.originalId && hasNavigation) {
          eventName = inboxEvents.getEventNameByNavigationMode(_this.navigationEventMode);
          _this.navigation = inboxEvents.getNavigation(_this.originalId, eventName);
        }
        _this.model.on('error invalid', _this.renderErrors, _this);
        _this.model.on('sync', _this.clearErrors, _this);
        _this.model.on('change:documentType', (function(model, type) {
          _this.selectType(type);
          return _this.toggleNotesView(type);
        }), _this);
        _this.model.on('change', _this.checkForTypeChange, _this);
        _this.model.on('change:id', _this.updateUrl, _this);
        _this.model.on('change:id change:relatedJE', _this.updateHeader, _this);
        _this.refreshOriginalDocumentType();
        return _this.render();
      };
      loader.init();
      this.model = new DocumentModel({
        id: this.originalId
      });
      this.model.once('init', function() {
        return init();
      });
      this.model.once('init.error', function() {
        _this.notFound = true;
        return init();
      });
      return this.loadingPromise = this.model.init();
    };

    /*
    # Speed up rendering - use precombined select element
    */


    DocumentEntryPage.prototype.prepareLedgerControl = function() {
      var ledger, ledgers, _i, _len, _results;
      this.ledgerControl = $('<select/>');
      ledgers = this.ledgerAccountsCollection.toJSON();
      _results = [];
      for (_i = 0, _len = ledgers.length; _i < _len; _i++) {
        ledger = ledgers[_i];
        _results.push(this.ledgerControl.append($('<option/>').attr('value', ledger.id).text(_s.trim(ledger.name))));
      }
      return _results;
    };

    DocumentEntryPage.prototype.render = function() {
      var data, documentType, headerPlaceholder, innerPlaceholder,
        _this = this;
      DocumentEntryPage.__super__.render.call(this, simpleTemplate);
      data = _.extend(this.model.toJSON(), {
        navigation: this.navigation,
        navigationEventMode: this.navigationEventMode
      });
      $('.widget_content').html(_.template(this.template, data));
      this.checkForTypeChange();
      this.updateViewerDimensions();
      this.$el.find('.document-entry-data').on('resize.document-entry', function() {
        return _this.updateViewerDimensions();
      });
      innerPlaceholder = this.$el.find('.entry-inner');
      headerPlaceholder = this.$el.find('.entry-header');
      headerPlaceholder.prepend(_.template(headerTemplate, this.model.toJSON()));
      documentType = this.model.get('documentType');
      this.selectType(documentType);
      this.notesView = new NotesView({
        model: this.model
      });
      innerPlaceholder.prepend(this.notesView.$el);
      this.notesView.updateType();
      this.generatedNameView = new GeneratedNameView({
        model: this.model
      });
      this.generatedNameView.$el.insertAfter(this.notesView.$el);
      this.internalNotesView = new InternalNotesView({
        internalNotes: this.model.get('internalNotes'),
        syncNotes: this.syncInternalNotes
      });
      this.internalNotesView.preventShowSubmit();
      innerPlaceholder.prepend('<div class="document-internal-notes-wrapper"></div>');
      this.$('.document-internal-notes-wrapper').prepend(this.internalNotesView.$el);
      this.toggleNotesView(documentType);
      this.transactionsView = new TransactionsView({
        model: this.model
      });
      innerPlaceholder.prepend(this.transactionsView.$el);
      this.transactionsView.ledgerControl = this.ledgerControl;
      this.transactionsView.renderError = this.renderError;
      this.transactionsView.getTypeElement = this.getTypeElement;
      this.transactionsView.safeSetType = this.safeSetType;
      this.transactionsView.initTransactionsTable();
      this.transactionsView.updateType();
      this.transactionsView.setupShortCuts();
      this.detailsView = new DetailsView({
        model: this.model,
        otherTypes: this.otherTypes,
        isTabular: this.isTabular,
        ledgerControl: this.ledgerControl,
        documentRequests: this.documentRequests
      });
      innerPlaceholder.prepend(this.detailsView.$el);
      this.detailsView.initDatePicker();
      this.detailsView.initLedgerControl();
      this.detailsView.parentPage = this;
      this.detailsView.renderError = this.renderError;
      if (this.shouldPrefill) {
        this.detailsView.prefillFromMetadata();
      }
      this.detailsView.updateType();
      if (core.getFeatureFlagValue("documentRequests")) {
        this.documentRequestView = new DocumentRequestView({
          model: this.model,
          documentRequestModel: this.documentRequests.findWhere({
            linkedDocumentId: this.model.get('financialDocumentId')
          })
        });
        innerPlaceholder.prepend(this.documentRequestView.$el);
      }
      this.actionsView = new ActionsView({
        model: this.model,
        navigation: this.navigation,
        navigationEventMode: this.navigationEventMode
      });
      innerPlaceholder.append(this.actionsView.$el);
      this.actionsView.originalId = this.originalId;
      this.actionsView.markInboxEventAsDone = this.markInboxEventAsDone;
      this.actionsView.exit = this.exit;
      this.actionsView.next = this.next;
      this.actionsView.updateActions();
      setTimeout(function() {
        return _this.initUploaderArea();
      }, 300);
      this.setupKeyboardShortcuts();
      if (this.notFound) {
        return this.initNotFoundMode();
      }
    };

    DocumentEntryPage.prototype.removeDocumentRequestView = function() {
      if (this.documentRequestView) {
        return this.documentRequestView.remove();
      }
    };

    DocumentEntryPage.prototype.syncInternalNotes = function(notes) {
      return this.model.set('internalNotes', notes);
    };

    DocumentEntryPage.prototype.initUploaderArea = function() {
      return new BkDocumentViewer({
        el: this.$el.find('.document-viewer'),
        document: this.model
      });
    };

    DocumentEntryPage.prototype.initNotFoundMode = function() {
      this.$el.find('.uploader-content').hide();
      this.$el.find('.not-found-area').show().css('height', this.$el.find('.entry-header').outerHeight() + this.$el.find('.entry-inner').outerHeight() + 'px');
      this.$el.find('.entry-footer button:not(.navigation-button)').prop('disabled', true);
      return this.markInboxEventAsDone();
    };

    DocumentEntryPage.prototype.refreshOriginalDocumentType = function() {
      return this.originalDocumentType = this.model.get('documentType');
    };

    DocumentEntryPage.prototype.setupKeyboardShortcuts = function() {
      var _this = this;
      return $(window).on('keydown.entry', function(e) {
        var code;
        code = e.which || e.keyCode;
        if (code === 13 && e.shiftKey) {
          e.preventDefault();
          _this.$el.find(':focus').blur();
          _this.saveAndExit();
          false;
        }
        if (code === 83 && (core.isMac() ? e.metaKey : e.ctrlKey)) {
          e.preventDefault();
          _this.save();
          false;
        }
        if (code === 27) {
          e.preventDefault();
          _this.exit();
          false;
        }
        if (code === 39 && (core.isMac() ? e.metaKey : e.ctrlKey)) {
          return _this.save(function() {
            return _this.next();
          });
        }
      });
    };

    DocumentEntryPage.prototype.updateViewerDimensions = function() {
      return this.$el.find('.document-viewer, .document-entry-wrapper').height(this.$el.find('.document-entry-data').height());
    };

    DocumentEntryPage.prototype.renderErrors = function() {
      var message, name, _ref, _results;
      this.clearErrors();
      _ref = this.model.validationError;
      _results = [];
      for (name in _ref) {
        message = _ref[name];
        _results.push(this.renderError(name, message));
      }
      return _results;
    };

    DocumentEntryPage.prototype.renderError = function(name, message, additionalClass, autohide, placement) {
      var element, errorTooltipTemplate;
      if (additionalClass == null) {
        additionalClass = null;
      }
      if (autohide == null) {
        autohide = false;
      }
      if (placement == null) {
        placement = 'in left';
      }
      errorTooltipTemplate = '<div class="tooltip validation-tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';
      element = $(".validation-" + name);
      element.tooltip('destroy').tooltip({
        title: message,
        placement: placement,
        trigger: 'manual',
        template: errorTooltipTemplate
      }).tooltip('show');
      if (additionalClass) {
        element.find('.tooltip').addClass(additionalClass);
      }
      if (autohide) {
        return setTimeout(function() {
          return element.tooltip('destroy');
        }, 2000);
      }
    };

    DocumentEntryPage.prototype.clearErrors = function() {
      this.$el.find('.validation-error').removeClass('validation-error');
      return $('.validation-tooltip').remove();
    };

    /*
    # Remove sub-views and main view after
    */


    DocumentEntryPage.prototype.remove = function() {
      var _ref;
      DocumentEntryPage.__super__.remove.apply(this, arguments);
      if ((_ref = this.model) != null) {
        _ref.off('init');
      }
      $('.validation-tooltip').remove();
      this.$el.find('.document-entry-data').off('resize.document-entry');
      $(window).off('resize.document-entry');
      $(window).off('keydown.entry');
      if (this.notesView) {
        this.notesView.remove();
      }
      if (this.generatedNameView) {
        this.generatedNameView.remove();
      }
      if (this.transactionsView) {
        this.transactionsView.remove();
      }
      if (this.documentRequestView) {
        this.documentRequestView.remove();
      }
      if (this.detailsView) {
        this.detailsView.remove();
      }
      if (this.actionsView) {
        return this.actionsView.remove();
      }
    };

    DocumentEntryPage.prototype.safeSetType = function(type) {
      var typeElement;
      typeElement = this.getTypeElement(type);
      if (!typeElement.hasClass('disabled')) {
        return this.model.set('documentType', type);
      }
    };

    DocumentEntryPage.prototype.getTypeElement = function(type) {
      return $(".document-type[data-type='" + (type.toLowerCase()) + "']");
    };

    DocumentEntryPage.prototype.selectType = function(type) {
      var typeElement;
      if (type = 'ADDONS') {
        type = this.model.get('documentType');
      }
      if (__indexOf.call(this.mainTypes, type) < 0 && __indexOf.call(this.addOnTypes, type) < 0) {
        type = 'OTHER';
      }
      typeElement = this.getTypeElement(type);
      $('.document-type').removeClass('selected');
      return typeElement.addClass('selected');
    };

    DocumentEntryPage.prototype.updateUrl = function() {
      var params, url;
      params = [this.model.get('id')];
      if (this.isSingle) {
        params.push('single');
      }
      url = core.getRouter().buildUrl(this.pageId, params);
      return core.getRouter().navigate(url, {
        replace: true
      });
    };

    DocumentEntryPage.prototype.updateType = function(type, silent) {
      if (silent == null) {
        silent = false;
      }
      this.model.set('documentType', type);
      if (!silent) {
        return this.selectType(type);
      }
    };

    DocumentEntryPage.prototype.toggleNotesView = function(type) {
      var isTransactional, _ref, _ref1;
      isTransactional = type === 'TRANSACTIONAL';
      if ((_ref = this.notesView.$el) != null) {
        _ref.toggle(!isTransactional);
      }
      return (_ref1 = this.internalNotesView.$el) != null ? _ref1.toggle(isTransactional) : void 0;
    };

    DocumentEntryPage.prototype.checkForTypeChange = function() {
      if (this.model.get('canChangeFinancialDocumentType') === false) {
        return $('.document-type:not(.selected)').addClass('disabled');
      } else {
        return $('.document-type').removeClass('disabled');
      }
    };

    DocumentEntryPage.prototype.updateHeader = function() {
      var templateData, _ref;
      templateData = this.model.toJSON();
      templateData.relatedJE = (_ref = templateData.relatedJE) != null ? _ref : null;
      return this.$el.find('.document-title').replaceWith(_.template(headerTemplate, templateData));
    };

    DocumentEntryPage.prototype.openRelatedJE = function(e) {
      var relatedJE;
      relatedJE = $(e.currentTarget).data('id');
      return core.getRouter().loadPage('document-entry', [relatedJE]);
    };

    DocumentEntryPage.prototype.openPotentialMatches = function(e) {
      var jeId;
      jeId = $(e.currentTarget).data('id');
      return new TransfersListView({
        jeId: jeId
      });
    };

    DocumentEntryPage.prototype.prev = function(fallback) {
      var _ref;
      if ((_ref = this.navigation) != null ? _ref.prevId : void 0) {
        return core.getRouter().loadPage('document-entry', [this.navigation.prevId, this.navigationEventMode], this.navigationQuery, '', true);
      } else {
        return typeof fallback === "function" ? fallback() : void 0;
      }
    };

    DocumentEntryPage.prototype.next = function(fallback) {
      var _ref;
      if ((_ref = this.navigation) != null ? _ref.nextId : void 0) {
        return core.getRouter().loadPage('document-entry', [this.navigation.nextId, this.navigationEventMode], this.navigationQuery, '', true);
      } else {
        return typeof fallback === "function" ? fallback() : void 0;
      }
    };

    DocumentEntryPage.prototype.save = function(success) {
      var options,
        _this = this;
      this.internalNotesView.createInternalNote();
      $(':focus').blur();
      options = {
        error: function(model, response) {
          return _this.showErrors(model, response);
        }
      };
      options.success = function() {
        _this.refreshOriginalDocumentType();
        _this.checkForTypeChange();
        _this.markInboxEventAsDone(success);
        return _this.associateDocumentRequest();
      };
      loader.init();
      this.model.once('sync error invalid', function() {
        return loader.hide();
      });
      return this.model.save({}, options);
    };

    DocumentEntryPage.prototype.associateDocumentRequest = function() {
      return this.documentRequests.trigger("associateDocument", this.model);
    };

    DocumentEntryPage.prototype.markInboxEventAsDone = function(callback) {
      var eventName, name;
      eventName = inboxEvents.getEventNameByNavigationMode(this.navigationEventMode);
      if ((this.navigation != null) || (eventName != null)) {
        name = eventName != null ? eventName : {
          eventName: this.navigation.eventName
        };
        return inboxEvents.markAsDone(this.originalId, name, callback);
      } else {
        return typeof callback === "function" ? callback() : void 0;
      }
    };

    DocumentEntryPage.prototype.showErrors = function(model, response) {
      var error, errors, _i, _len, _ref, _results;
      try {
        errors = JSON.parse(response.responseText);
      } catch (e) {

      }
      if (!_.isObject(errors) || !_.isArray(errors.messages)) {
        return;
      }
      _ref = errors.messages;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        error = _ref[_i];
        _results.push(this.showNotification({
          type: 'error',
          text: error.message
        }));
      }
      return _results;
    };

    DocumentEntryPage.prototype.saveAndExit = function() {
      var promise,
        _this = this;
      promise = this.save();
      if (!promise) {
        return;
      }
      return promise.done(function() {
        return _this.exit();
      });
    };

    DocumentEntryPage.prototype.exit = function() {
      var router;
      router = core.getRouter();
      if (router.history.length > 1) {
        return router.back();
      } else {
        return router.navigate(router.buildUrl('upload'));
      }
    };

    return DocumentEntryPage;

  })(mixin.of(BaseView, NotificationSupport));
});
